import { inject, observer } from "mobx-react";
import { fn_delivery_call, fn_show_call } from "function/FnBodyStep";
import {
  fn_layerCstView,
  fn_order_complete_layer,
  fn_order_payment_alert_show,
  fn_self_delivery_complet,
  fn_pos_order_complete_layer,
} from "function/FnBodyLayer";
import { fn_bridge_pos_order_call } from "function/FnPosBridge";
import { fn_orderEndDetail } from "function/FnBodyDetail";
import {
  getDepositCheck,
  ygyMobileOrderFg,
  posOrdermMbileOrderFg,
  analyticeEvent,
  posOrderCallType,
} from "utils/Utils";
import { isExpressDeliveryOrder, isHookingOrder, isPaidOrder } from "utils/CheckerOrderGroups";
import { ygy_auto_cancel, fn_cooking_complete } from "http/StepConn";
import { MobileOrderFg, StepCd } from "types";

const OrderListButtonViewCase = ({ rootStore, order, searchStore }) => {
  const checkDelivery = isExpressDeliveryOrder(order);
  const checkHooking = isHookingOrder(order);
  const checkPaid = isPaidOrder(order);

  let depositCk = getDepositCheck(order);
  let detailType = "";
  let callType = posOrderCallType(rootStore, order);

  if (
    (searchStore.getCurrStepType === "all" && order.stepType === "READY") ||
    searchStore.getCurrStepType === "ready"
  ) {
    detailType = "ready";
  } else if (
    (searchStore.getCurrStepType === "all" && order.stepType === "COOKING") ||
    searchStore.getCurrStepType === "cooking"
  ) {
    detailType = "cooking";
  } else if (
    (searchStore.getCurrStepType === "all" && order.stepType === "DELIVERY") ||
    searchStore.getCurrStepType === "delivery"
  ) {
    if ((order.dlvStatusFg === null || order.dlvStatusFg === "99") && order.stepCd === "500") {
      detailType = "cooking";
    } else {
      detailType = "delivery";
    }
  }

  function onClickActionBtn() {
    //pos,키오스크 주문채널 추가
    if (posOrdermMbileOrderFg(order.mobileOrderFg) && order.stepCd !== "700" && order.stepCd !== "900") {
      if (order.stepCd === "200") {
        if (callType !== "") {
          analyticeEvent("kdsPickupCall", "kdsPickupCallList Button", "Button");
          fn_bridge_pos_order_call(rootStore, order, "", callType);
        } else {
          analyticeEvent("kdsOrderPickupComplete", "orderPickupCompleteList Button", "Button");
          fn_pos_order_complete_layer(rootStore, order);
        }
      } else if (order.stepCd === "300") {
        analyticeEvent("kdsOrderPickupComplete", "orderPickupCompleteList Button", "Button");
        fn_pos_order_complete_layer(rootStore, order);
      }
    } else {
      if (detailType === "ready") {
        ygyMobileOrderFg(order.mobileOrderFg)
          ? ygy_auto_cancel(rootStore, order.mobileOrderNo, order.mobileOrderFg, order.morderTypeCd)
          : fn_layerCstView(rootStore, order.mobileOrderNo, "orderAcceptCard Button");
      } else if (detailType === "cooking") {
        if (order.orderType === "DELIVERY") {
          checkDelivery
            ? order.gstPayAmt !== 0
              ? fn_order_complete_layer(rootStore, order.mobileOrderNo, "orderCompleteList Button")
              : fn_self_delivery_complet(rootStore, true, order.mobileOrderNo, "orderCompleteList Button")
            : fn_delivery_call(rootStore, order.mobileOrderNo, "riderCallList Button");
        } else if (order.orderType === "PICKUP") {
          checkPaid
            ? fn_show_call(rootStore, order.mobileOrderNo)
            : order.payType === "PAID" && depositCk === true
            ? fn_order_complete_layer(rootStore, order.mobileOrderNo, "orderPickupCompleteList Button")
            : fn_order_payment_alert_show(rootStore, order.mobileOrderNo, "orderPickupCompleteList Button");
        } else {
          checkHooking || (order.orderType === "TABLE" && order.mobileOrderFg === "27")
            ? depositCk === true
              ? fn_order_complete_layer(rootStore, order.mobileOrderNo, "orderPickupCompleteList Button")
              : fn_order_payment_alert_show(rootStore, order.mobileOrderNo, "orderPickupCompleteList Button")
            : fn_show_call(rootStore, order.mobileOrderNo);
        }
      } else if (detailType === "delivery") {
        if (order.orderType === "DELIVERY") {
          //요기요 조리완료(픽업중)
          if (order.mobileOrderFg === "31" && (order.dlvStatusFg === "00" || order.dlvStatusFg === "02")) {
            fn_cooking_complete(rootStore, order);
          } else {
            order.gstPayAmt !== 0
              ? fn_order_complete_layer(rootStore, order.mobileOrderNo, "orderCompleteList Button")
              : fn_self_delivery_complet(rootStore, true, order.mobileOrderNo, "orderCompleteList Button");
          }
        } else {
          depositCk === true
            ? fn_order_complete_layer(rootStore, order.mobileOrderNo, "orderPickupCompleteList Button")
            : fn_order_payment_alert_show(rootStore, order.mobileOrderNo, "orderPickupCompleteList Button");
        }
      } else if (order.stepCd === "700" || order.stepCd === "900") {
        fn_orderEndDetail(rootStore, order.mobileOrderNo, "endOrderView");
      }
    }
  }

  function btnTypeTxt() {
    let txt = "";
    //pos,키오스크 주문채널 추가
    if (posOrdermMbileOrderFg(order.mobileOrderFg)) {
      if (order.stepCd === "200") {
        if (!!callType) {
          txt = "호출";
        } else {
          txt = "픽업완료";
        }
      } else if (order.stepCd === "300") {
        txt = "픽업완료";
      }
    } else {
      if (detailType === "ready") {
        txt = "주문접수";
      } else if (detailType === "cooking") {
        if (order.orderType === "DELIVERY") {
          checkDelivery ? (txt = "배달완료") : (txt = "배달요청");
        } else if (order.orderType === "PICKUP") {
            checkHooking
              ? (txt = "픽업완료")
              : order.partnerType === "CID"
              ? order.payType === "PAID" && depositCk === true
                ? (txt = "픽업완료")
                : (txt = "픽업결제")
              : (txt = "호출");
        } else {
          checkHooking || (order.orderType === "TABLE" && order.mobileOrderFg === "27")
            ? (txt = "완료처리")
            : (txt = "호출");
        }
      } else if (detailType === "delivery") {
        if (order.orderType === "DELIVERY") {
          if (order.mobileOrderFg === "31" && (order.dlvStatusFg === "00" || order.dlvStatusFg === "02")) {
            txt = "조리완료";
          } else {
            txt = "배달완료";
          }
        } else {
          txt = "픽업완료";
        }
      }
    }

    return txt;
  }

  function getButtonColor() {
    const { orderType, stepCd, mobileOrderFg, payType, dlvStatusFg } = order;

    // 포스, 키오스크, 테이블, QR 주문
    if (posOrdermMbileOrderFg(order.mobileOrderFg)) {
      if (stepCd === StepCd.ACCEPTED) {
        return !!callType ? "s" : "complete";
      }
      if (stepCd === StepCd.PICKUP_REQUEST) {
        return "complete";
      }
    }

    // 주문 수락 전
    if (detailType === "ready") {
      return "s";
    }

    // 주문 수락 및 조리 중
    if (detailType === "cooking") {
      if (orderType === "DELIVERY") {
        return checkDelivery ? "complete" : "s";
      }
      if (orderType === "PICKUP") {
        return checkPaid ? "s" : payType === "PAID" && depositCk ? "complete" : "s";
      }
      return checkHooking || (orderType === "TABLE" && mobileOrderFg === MobileOrderFg.YOGIYO) ? "complete" : "s";
    }

    // 조리 끝 배달 요청
    if (detailType === "delivery") {
      if (orderType !== "DELIVERY") return "complete";
      return mobileOrderFg === MobileOrderFg.YOGIYO_EXPRESS && ["00", "02"].includes(dlvStatusFg) ? "s" : "complete";
    }

    // 주문 완료 및 취소
    if (stepCd === StepCd.ORDER_COMPLETED) {
      return "complete end";
    }
    if (stepCd === StepCd.ORDER_CANCELLED) {
      return "complete cancel";
    }

    return "";
  }

  function getOrderEndLabel() {
    const { stepCd } = order;
    if (stepCd === StepCd.ORDER_COMPLETED) return "완료주문";
    if (stepCd === StepCd.ORDER_CANCELLED) return "취소주문";

    return "";
  }

  return (
    <>
      <span className={order.stepCd === StepCd.ORDER_COMPLETED ? "btn_cancel show" : "hide"}></span>
      <button type="button" className={getButtonColor()} onClick={() => onClickActionBtn()}>
        {order.stepCd === StepCd.ORDER_COMPLETED || order.stepCd === StepCd.ORDER_CANCELLED ? (
          <span className="btn_end">{getOrderEndLabel()}</span>
        ) : (
          btnTypeTxt()
        )}
      </button>
    </>
  );
};

export default inject("rootStore")(observer(OrderListButtonViewCase));
